/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { SKIP_ERROR_INTERCEPTOR } from '../models/context/SkipErrorInterceptorContext';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private dialogRef: MatDialog,
    private authService: AuthenticationService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const skip = req.context.get(SKIP_ERROR_INTERCEPTOR);

    if (skip) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      catchError((error) => {
        if ([500].includes(error.status)) {
          this.router.navigate(['']);
          this.snackBar.open(
            'Error code: 500. An error has occurred, and we are working to fix the problem!',
            null,
            {
              duration: 3000,
              panelClass: ['error-snackbar'],
            },
          );
          this.dialogRef.closeAll();
        } else if ([401].includes(error.status)) {
          if (this.authService.getCurrentAuthMethod() === 'jwt') {
            this.authService.logout();
            this.dialogRef.closeAll();
          }
        } else if (
          ![401].includes(error.status) &&
          ![200].includes(error.status)
        ) {
          if (error?.error?.message) {
            this.snackBar.open(error?.error?.message, null, {
              duration: 3000,
              panelClass: ['error-snackbar'],
            });
          }
          this.dialogRef.closeAll();
        }
        return throwError(error);
      }),
    );
  }
}
